import type { AppointmentFormValues } from './appointmentForm';

export type AppointmentCascadeField =
  | 'clinicId'
  | 'doctorId'
  | 'chairId'
  | 'type'
  | 'duration'
  | 'date'
  | 'startTime';

/**
 * Centralized downstream clears when an upstream booking field changes.
 * Returns a shallow patch to merge into Formik values (does not include the changed field itself).
 */
export const applyAppointmentCascadeClear = (
  _prev: AppointmentFormValues,
  field: AppointmentCascadeField,
  _nextValue: unknown
): Partial<AppointmentFormValues> => {
  switch (field) {
    case 'clinicId':
      return {
        chairId: '',
        date: null,
        startTime: '',
      };
    case 'doctorId':
    case 'chairId':
    case 'type':
    case 'duration':
    case 'date':
      // Keep the chosen time. SchedulePanel drops it only after slots reload
      // and the time is blocked or gone.
      return {};
    case 'startTime':
      return {};
    default:
      return {};
  }
};
